























import { APP_EVENTS, APP_PATH_REGEX } from '@/common/constants'
import Vue from 'vue'
import eventBus from '@/common/utils/eventBus'
import { SEARCH_TRACKING_QUERY } from '@/common/utils/eventTracker'

export default Vue.extend({
  data(): {
    keyword: string,
    isSearchView: boolean
  } {
    return {
      keyword: '',
      isSearchView: false
    }
  },
  created() {
    const currentPath = window.location.pathname
    this.isSearchView = (APP_PATH_REGEX.SEARCH).test(currentPath)
    if (this.isSearchView) {
      const parsedUrl = new URL(window.location.href)
      const keywordQuery = parsedUrl.searchParams.get('keyword') || ''
      this.keyword = keywordQuery
    }
  },
  methods: {
    submit() {
      if (this.isSearchView) {
        eventBus.$emit(APP_EVENTS.SEARCH_KEYWORD_APPLY, this.keyword)
        this.$emit('onSearch')
      } else {
        location.href = `/search?keyword=${this.keyword}&${SEARCH_TRACKING_QUERY}=true`
      }
    }
  }
})
